<template>
  <div :style="themeStyle" height="100%" style="background-color:#F2F2F2" v-if="shopId">
    <v-row class="headline1_bg p-3" no-gutters>
      <v-col cols="12" :style="{'color': isTargetShop ? '#000' : $CUSTOMMainTextColor}" @click="$router.go(-1)">
        <b> <v-icon>mdi-chevron-left</v-icon>  {{ isTargetShop?  $t("message.campaign")  : $t("message.promotion")}}</b>
      </v-col>
    </v-row>
    <v-container class="pt-5" v-if="item" height="100%" style="background-color:#F2F2F2">
      <v-card
        class="mx-auto rounded-lg"
        elevation="0"
        height="100%"
        flat
        tile
      >
        <v-img class="white--text align-end" :src="item.promotionPicture"
        >
        </v-img>
        <v-container fluid>
          <v-row v-if="$i18n.locale === 'th' || item.promotionNameEng === '' || item.promotionNameEng === null">
              <v-col class="bold font18" :style="{'color': $CUSTOMMainTextColor}">{{item.promotionName}}</v-col>
          </v-row>
          <v-row v-if="$i18n.locale === 'en' && item.promotionNameEng !== null && item.promotionNameEng !== ''">
              <v-col class="bold font18" :style="{'color': $CUSTOMMainTextColor}">{{item.promotionNameEng}}</v-col>
          </v-row>
          <!-- <v-row v-if="item.promotionSubName">
              <v-col class="bold font14  :style="{'color': $CUSTOMMainTextColor}"pt-0"><nl2br tag="p" :text="item.promotionSubName" /></v-col>
          </v-row> -->
          <v-row v-if="$i18n.locale === 'th' || item.promotionDetailsEng === '' || item.promotionDetailsEng === null">
            <v-col class="icon2 font14" v-html="makeLinksClickable(item.promotionDetails)"></v-col>
          </v-row>
          <v-row v-if="$i18n.locale === 'en' && item.promotionDetailsEng !== null && item.promotionDetailsEng !== ''">
              <v-col class="icon2 font14" v-html="makeLinksClickable(item.promotionDetailsEng)"></v-col>
          </v-row>
        </v-container>
        <v-card-actions :style="(item.packageId && item.packageId !== 'None') && (item.packagePrice !== '0' && item.packagePrice !== null ) ? 'background-color:' + this.$bgColor : ''">
          <v-btn
            class="rounded-lg"
            text
            block
            dark
            :disabled="canbuy"
            v-if="(item.packageId && item.packageId !== 'None') && (item.packagePrice !== '0' && item.packagePrice !== null )"
             @click="$router.push(`/BuyPackage/${item.packageId}`)"
          >
          {{ $t("message.buyPackage") }}
          </v-btn>
          <v-btn
            class="rounded-lg"
            text
            block
            dark
            :disabled="canbuy"
            v-if="item.packageId && item.packagePrice === '0'"
            @click="getFreePackage()"
          >
          {{ $t("message.freePackage") }}
          </v-btn>
          <v-btn
            class="rounded-lg"
            text
            block
            dark
            v-if="!item.packageId"
            @click="$router.push('/C/promotion')"
          >
          {{ $t("message.backToPromotion") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'RewardDetail',
  data () {
    return {
      id: this.$route.params.id,
      item: null,
      member: null,
      profile: null,
      shopId: null,
      canbuy: false,
      createQRcodePackage: {
        packageId: '',
        status: 'waiting',
        CREATE_USER: '',
        liffId: '',
        LAST_USER: '',
        shopId: '',
        CREATE_DATE: '',
        chkQRCode: 1
      }
    }
  },
  computed: {
    isTargetShop () {
      return this.$isTargetShop()
    }

  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    this.shopId = this.GET_SHOPID()
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    await this.checkliff()
    await this.getDetailPromotion()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    async getDetailPromotion () {
      const result = await this.callBeTaskAPI('get', `/promotion/getID?id=${this.id}`)
      if (result) {
        this.item = result
      }
      if (this.item.limitPackage.toLowerCase() === 'true') {
        const resultPro = await this.callBeTaskAPI('get', `/PackageLog/get?packageId=${this.item.packageId}&memberId=${this.profile.memberId}`)
        if (Array.isArray(resultPro)) {
          for (let i = 0; i < resultPro.length; i++) {
            const currentItem = resultPro[i]
            if (currentItem.status === 'get' || currentItem.status === 'use') {
              this.canbuy = true
              break
            } else if (currentItem.status === 'cancel') {
              this.canbuy = false
            }
          }
          // this.canbuy = true
        } else {
          this.canbuy = false
        }
      }
    },
    makeLinksClickable (text) {
      // eslint-disable-next-line no-useless-escape
      const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
      const linkedText = text.replace(urlPattern, '<a href="$1" target="_blank">$1</a>')
      const textWithBreaks = linkedText.replace(/\n/g, '<br>')
      return textWithBreaks
    },
    async getFreePackage () {
      this.createQRcodePackage.packageId = this.item.packageId
      this.createQRcodePackage.CREATE_USER = this.profile.userId
      this.createQRcodePackage.LAST_USER = this.profile.userId
      this.createQRcodePackage.memberId = this.profile.memberId
      this.createQRcodePackage.liffId = this.$liffId
      this.createQRcodePackage.shopId = this.shopId
      this.createQRcodePackage.masBranchID = ''
      await axios
        .post(this.DNS_IP + '/packageQRcode/add', this.createQRcodePackage)
        .then(async response => {
          // console.log('addDataGlobal DNS_IP + PATH + "add"', response)
          const paramsCollectPackage = {
            'token': response.data.token
          }
          let config = {
            headers: {
              shopId: this.shopId,
              lineId: this.profile.userId,
              memberId: this.profile.memberId
            }
          }
          await axios
            .post(
              this.DNS_IP +
                '/collect_package/edit',
              paramsCollectPackage, config
            )
            .then(response => {
              this.loaded = false
              Swal.fire({
                title: 'รับแพ็กเกจสำเร็จ',
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#b3b1ab',
                confirmButtonText: 'ตกลง'
              }).then((confirm) => {
                if (confirm.isConfirmed) {
                  if (!this.$isTargetShop()) {
                    this.$router.push('/MyPackage')
                  } else {
                    this.$router.push('/C/MyPackage')
                  }
                }
              })
              // console.log('res', res)
              // console.log('assign', this.veiwQRCode)
            })
          // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          // this.loadingAdd = false
        })
        .catch(error => {
          console.error('error function addDataGlobal : ', error)
          this.$router.push(
            '/system/Errorpage?returnLink=' + this.returnLink
          )
          this.dataReady = true
        })
    },
    async checkliff () {
      const result = await axios.get(this.DNS_Link + `/lineconfig/get?shopId=${this.shopId}`)
      if (Array.isArray(result.data)) {
        // alert('find')
        if (result.data[0].liffMainIDLoyalty !== null) {
          this.$liffId = result.data[0].liffMainIDLoyalty
        } else {
          this.$liffId = '1656906322-JN5MM8Ep'
        }
      } else {
        this.$liffId = '1656906322-JN5MM8Ep'
      }
    }
  }
}
</script>
<style scoped>
.theme--light.v-card {
  background-color: #F2F2F2 !important;
}
.headline1_bg {
  background-color: #FFA300 !important;
}
.v-sheet.v-card {
    background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Promotion/Detail.vue